<template>
  <div>
    <Navigation />
    <div class="logged-in participant-layout">
      <router-view></router-view>
      <small class="credits has-text-grey-light">© {{ currentYear }} Global Martial Arts University and Hodgy LLC. All Rights Reserved.</small>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation/Navigation'

export default {
  name: 'ParticipantLayout',
  components: {
    Navigation
  },
  mounted () {
    this.$store
      .dispatch('admin/GET_EVENTS')
      .then(res => {
        if (res.data.events.length > 0) {
          this.$store.commit('saveEvents', res.data.events)

          let event = res.data.events.filter(item => {
            return item.activeEvent
          })[0]
          this.$store.commit('saveEvent', event)
        }
      })
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
.credits {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0px;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  background: #f1f5f8;
  height: 40px;
}
</style>
